import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  font-family: "Lato", sans-serif;
  color: var(--cinza-90);

  strong {
    font-size: 15px;
    line-height: 22px;
    color: var(--cinza-100);
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 21px;
  }

  .topo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
`;

export const Selo = styled.span`
  flex: none;
  font-size: 12px;
  font-weight: 700;
  color: #17742a;
  background: var(--principal-20);
  padding: 3px 10px;
  border-radius: 99px;

  &.neutro {
    color: var(--cinza-80);
    background: var(--cinza-20);
    border: 1px solid var(--cinza-30);
  }
`;

export const Concluido = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px 20px;
  background: var(--principal-10);
  border-radius: 10px;

  .topo strong {
    font-size: 17px;
    font-weight: 900;
  }

  > p {
    font-size: 15px;
    line-height: 22px;
  }
`;

export const Dados = styled.div`
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr);
  row-gap: 6px;
  font-size: 14px;

  span {
    color: var(--cinza-70);
  }

  b {
    color: var(--cinza-100);
  }
`;

export const BotaoPrincipal = styled.a`
  align-self: flex-start;
  padding: 12px 20px;
  border-radius: 8px;
  background: var(--principal-50);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: #fff;
    background: #17742a;
  }
`;

export const BotaoSecundario = styled.a`
  align-self: flex-start;
  padding: 10px 18px;
  border-radius: 8px;
  border: 2px solid var(--principal-50);
  background: #fff;
  color: #17742a;
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;

  &:hover {
    color: #17742a;
    background: var(--principal-10);
  }
`;

export const AvisoEstadoCivil = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px;
  background: var(--atencao-10);
  border-radius: 10px;
`;

export const Titulo = styled.strong`
  && {
    font-size: 16px;
    font-weight: 900;
  }
`;

export const Passos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 18px;
  border: 1px solid var(--cinza-30);
  border-radius: 10px;

  ol {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    gap: 12px;

    > span {
      flex: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      border: 1px solid var(--cinza-40);
      font-size: 12px;
      font-weight: 700;
    }
  }
`;

export const Consulados = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px;
  border: 1px solid var(--cinza-30);
  border-radius: 10px;

  p {
    font-size: 13px;
    color: var(--cinza-80);
  }
`;

export const Rodape = styled.p`
  && {
    color: var(--cinza-80);
  }
`;
